export default __webpack_public_path__ + "static/media/twitterLogo.1ffbac95.jpg";